import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export const useValidateEmail = () => {
  const { formatMessage } = useIntl();

  const validateEmail = useCallback((email: string) => {
    if (!email.trim()) {
      return formatMessage({ id: 'error.fieldCannotBeEmpty' });
    }

    if (!/^[-a-z0-9_.]+@([-a-z0-9]+.)+[a-z]{2,6}$/.test(email)) {
      return formatMessage({ id: 'erorr.emailNotValid' });
    }    
  }, [formatMessage]);

  return validateEmail;
};